import angular from 'angular';
import ComponentsModule from '../components-module';

const COMPONENT_NAME = 'CodeContentEditor';

/**
 * CodeContentEditor, responsible for encapsulating all content editor navigation logic.
 */
angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, ($location, $route, RecentContentService) => {
    return {
      openContent: (contentId, forceReload, mode) => {
        let editorPathPrefix = mode === 'edit' ? '/edit/' : '/content/';
  
        if (!mode) {
          let editorState = RecentContentService.getEditorStateFor(contentId);
          editorPathPrefix = (editorState.mode === 'edit') ? '/edit/' : '/content/';
        }
  
        let oldUrl = $location.url();
        let newUrl = $location.path(editorPathPrefix + contentId).url();
        $location.search ({});
  
        if (forceReload && oldUrl === newUrl) {
          $route.reload();
        }
      },
  
      openVersion: (versionId) => {
        $location.search({}).path('/version/' + versionId);
      },
  
      getContentLink: (contentId) => {
        let editorState = RecentContentService.getEditorStateFor(contentId);
        let editorPathPrefix = (editorState.mode === 'edit') ? '/edit/' : '/content/';
  
        return '#' + editorPathPrefix + contentId;
      },
  
      editContent: (contentId) => {
        $location.search({}).path('/edit/' + contentId);
      },
  
      editVersion: (versionId, currentRevision) => {
        $location.search({ currentRevision }).path('/editVersion/' + versionId);
      }
    };
  });

export default COMPONENT_NAME;
